import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown";
// import { apiHeader } from "helpers/api_helper";
import { withRouter, Link, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.ico";
import { useHistory } from "react-router";
import "../../assets/css/style.css";
import { toastCatchError } from "admin/commonFunction";
import PasswordTypeComp from "components/Common/PasswordTypeComp";
import { errorMsgHandler } from "common/errorMsgHandler";
import { adminLogin } from "services/services";
import shortLogo from "../../assets/images/logo-white.png";

const Login = ({ t }) => {
  //meta title
  // document.title = "Login";
  const [passwordType, setPasswordType] = useState("password");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const history = useHistory();
  const [loader, setLoader] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required(t("Please Enter Your Email")),
      password: Yup.string().required(t("Please Enter Your Password")),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        console.log("🔵 STEP 1: Calling adminLogin API...");
        const resp = await adminLogin(values);
        console.log("🟢 STEP 2: Login API Response received:", resp);
        
        const payload = resp?.data ?? resp;
        const statusCode = resp?.status ?? payload?.status ?? payload?.data?.status;
        
        console.log("📦 STEP 3: Parsed payload:", payload);
        console.log("📊 STEP 4: Status code:", statusCode);
        
        if (statusCode == 200 || payload?.data?.status == 200 || payload?.status == 200) {
          console.log("✅ STEP 5: Login successful! Storing in localStorage...");
          localStorage.setItem("authUser", JSON.stringify(payload));
          
          const stored = localStorage.getItem("authUser");
          console.log("💾 STEP 6: Verification - Stored data:", stored);
          
          const parsed = JSON.parse(stored);
          // Check for token in both possible locations: data.data.token OR data.token
          const token = parsed?.data?.data?.token || parsed?.data?.token;
          console.log("🎫 STEP 7: Token found in storage:", token ? token.substring(0, 30) + "..." : "❌ No token!");
          console.log("🔍 Debug - Parsed structure:", parsed);
          console.log("🔍 Debug - Token location:", {
            'data.data.token': parsed?.data?.data?.token ? 'Found' : 'Not found',
            'data.token': parsed?.data?.token ? 'Found' : 'Not found'
          });
          
          console.log("🚀 STEP 8: Redirecting to dashboard...");
          history.push("/admin/dashboard");
        } else {
          console.error("❌ Login failed - Invalid status code:", statusCode);
        }
      } catch (error) {
        console.error("❌ Login error:", error);
        toastCatchError(t(`${errorMsgHandler(error)}`));
      } finally {
        setLoader(false);
      }
    },
  });

  const { error } = useSelector((state) => ({
    error: state.Login.error,
  }));

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          {/* <i className="bx bx-home h2" /> */}
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft" style={{ background: "var(--brand)" }}>
                  <Row>
                    <Col xs={7}>
                      <div className=" p-4 pe-1">
                        <h5 className="text-white">{t("Welcome Back")} !</h5>
                        <p className="text-white">
                          {t("Sign in to continue to Quotivo")}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="#" className="auth-logo-light">
                      <div
                        className="avatar-md profile-user-wid mb-4 bg-soft"
                        style={{ height: "4.5rem", width: "5.5rem" }}
                      >
                        <span
                          className="avatar-title rounded border"
                          style={{
                            background: "#fff",
                          }}
                        >
                          <img src={shortLogo} height="35" className="" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <Label className="form-label">{t("Email")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder=""
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 position-relative">
                        <Label className="form-label">{t("Password")}</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type={passwordType}
                          placeholder=""
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />

                        <PasswordTypeComp
                          passwordType={passwordType}
                          setPasswordType={setPasswordType}
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      {/* <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div> */}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn auth-common-btn"
                          type="submit"
                          disabled={loader}
                        >
                          {loader ? `${t("Loading")} ...` : t("Log In")}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          {t("Forgot your password?")}
                        </Link>
                      </div>
                    </Form>
                    {/* <div className="text-center">
                      {" "}
                      <strong>Language: </strong>
                      <LanguageDropdown />
                    </div> */}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="text-white d-none">
                  © {new Date().getFullYear()} .{" "}
                  {t("Design & Developed by Code Brew Labs")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(Login));
Login.propTypes = {
  history: PropTypes.object,
};
